<template>
  <div class="order-card-wrapper">
    <div class="card p-3">
      <div class="card-main">
        <div class="line-item">
          <span>Order Id:</span>
          <span>{{orderObject.id}}</span>
        </div>
        <div class="line-item">
          <span>Date:</span>
          <span>{{$moment(orderObject.createdAt.toDate()).fromNow()}}</span>
        </div>
        <div class="line-item">
          <span>Type:</span>
          <span>{{orderObject.type}}</span>
        </div>
        <div class="line-item">
          <span>Status:</span>
          <b-badge pill variant="primary" v-if="orderObject.status===1">Processing</b-badge>
          <b-badge pill variant="info" v-if="orderObject.status===2">Dispatch</b-badge>
          <b-badge pill variant="success" v-if="orderObject.status===3">Completed</b-badge>
          <b-badge pill variant="danger" v-if="orderObject.status===4">Cancelled</b-badge>
        </div>
        <div class="line-item">
          <span>Total:</span>
          <span>{{orderObject.total| currency('€')}}</span>
        </div>

        <b-collapse :id="orderObject.id" v-model="visible" class="mt-2">
          <div v-if="Object.values(orderObject.order).length>0" class="cart-items">
            <template v-for="(item) in orderObject.order">
              <div :key="'selected'+item.id" class="selected-options mb-2">
                <ItemCard :item="item" :editable="false" />
              </div>
            </template>
            <hr />
            <div class="total d-flex justify-content-between">
              <span>Total</span>
              <span>{{orderObject.total| currency('€')}}</span>
            </div>
          </div>
        </b-collapse>
        <b-button
          size="sm"
          @click="visible = !visible"
          variant="primary"
        >View {{visible? 'Less':'More'}}</b-button>
        <b-button
          size="sm"
          v-if="visible"
          @click="addBulkItemsToCart"
          variant="primary"
          class="pull-right"
        >Re-order</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import ItemCard from "./ItemCard";
import { mapActions } from "vuex";
export default {
  props: {
    orderObject: Object
  },
  components: {
    ItemCard
  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    ...mapActions({
      addBulkToCart: "Cart/addBulkToCart"
    }),
    addBulkItemsToCart() {
      this.addBulkToCart(Object.values(this.orderObject.order));
      this.$router.push({ name: "checkout" });
    }
  }
};
</script>

<style scoped>
.line-item {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}
span:first-child {
  font-weight: 600;
}
span:nth-child(2) {
  text-align: end;
}
</style>